// Cột hiển thị 1 bước ký ở chế độ TẠO MỚI (chọn người tham gia) — markup như V1.
import React from "react";
import SearchBoxModal from "../../component/SearchBoxModal";

export default function ProcessStepCreate({
  step,
  stepIndex,
  tempUser,
  setTempUser,
  resetKey,
  handleAddMember,
  handleRemoveMember,
  extractFullname,
}) {
  const list_department = Array.isArray(step.list_progress) ? step.list_progress : [];

  return (
    <div className="col-12 col-sm-4 mb-3 item-totrinh" key={step.id + "_" + stepIndex}>
      <div className="wrapper border rounded shaddow">
        <h4 className="text-center item-header pl-3 pr-3 pt-2 pb-2 border-bottom">
          {stepIndex + 1}. {step.title}
        </h4>
        <div className="w-100 pl-3 pr-3 pt-2 pb-2 info">
          {list_department.map((d, progIndex) => {
            d.list_kyphu = Array.isArray(d.list_kyphu) ? d.list_kyphu : [];
            return (
              <div className="w-100 mb-2" key={progIndex}>
                <div className="user-status">
                  {d.user_label ? (
                    <div className="">
                      <strong>{d.user_label}</strong>
                      <br />
                    </div>
                  ) : (
                    <strong>Người chịu trách nhiệm</strong>
                  )}
                  <div className="check_status">
                    {d.action == 1 ? (
                      <p className="text-success">
                        <span className="fas fa-clock"></span>
                        <i> Đã ký</i>
                      </p>
                    ) : (
                      <p className="text-warning">
                        <span className="fas fa-clock"></span>
                        <i> Chờ ký</i>
                      </p>
                    )}
                  </div>
                  <button
                    type="button"
                    className="btn btn-sm btn-link text-danger p-0"
                    onClick={() => handleRemoveMember(step.id, d.user_id)}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>

                {d.list_kyphu.map((kp) => (
                  <div className="user-status" key={kp.user_id}>
                    <strong>{kp.fullname}</strong>
                    <div className="check_status">
                      <p className="text-warning">
                        <span className="fas fa-clock"></span>
                        <i> Chờ ký</i>
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            );
          })}
          <div className="w-100 border-top mt-2 p-2">
            <SearchBoxModal
              apiname={"users"}
              placeholder="Chọn nhân sự"
              colvalue={"id"}
              colname={"fullname"}
              name={`member_${step.id}`}
              value={tempUser[step.id]?.user_label || ""}
              defaultValue={""}
              resetKey={resetKey}
              onChange={(id) =>
                setTempUser((prev) => ({
                  ...prev,
                  [step.id]: { ...(prev[step.id] || {}), user_id: id },
                }))
              }
              onLabel={(label) =>
                setTempUser((prev) => ({
                  ...prev,
                  [step.id]: { ...(prev[step.id] || {}), user_label: extractFullname(label) },
                }))
              }
            />
            <button
              type="button"
              className="btn btn-sm btn-primary mt-2 w-100"
              onClick={() => handleAddMember(step.id)}
            >
              <i className="fas fa-user-plus"></i> Thêm người
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
